import * as React from "react"
import MuiCircularProgress from "@mui/material/CircularProgress"

// export interface BoxProps extends MuiBoxProps {}

export default function CircularProgress(props: any) {
  return <MuiCircularProgress {...props} />
}
